<template functional>
  <div>
    <component
      :is="$options.components.IconSvg"
      :icon="props.variant"
      :ref="data.ref"
      :class="[data.class, data.staticClass]"
      :style="[data.style, data.staticStyle]"
      v-bind="data.attrs"
      v-on="listeners"
    />
  </div>
</template>

<script>
import IconSvg from "./IconSvg";
export default {
  functional: true,
  name: "Logo",
  components: {
    IconSvg,
  },
  props: {
    variant: {
      default: "logo",
      type: String,
      validator: (value) => {
        return [
          "logo",
          "logo-small",
          "logo-white",
          "logo-white-small",
        ].includes(value);
      },
    },
  },
};
</script>
